import React from 'react'
import Logo from '../../Logo/Logo'
import { Link } from 'react-router-dom'
import { useStoreState } from '../../../store'

const Header = props => {
    const { settings } = useStoreState()
    return (
        <header className="site-header">
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <Logo file={'logo.svg'} alt="ViaCamp – obozy i kolonie dla dzieci i młodzieży" width="270" height="70" />
                    </div>
                    {settings && settings.transport_button ? (
                        <div className="col-12 col-md-6 d-flex align-items-center">
                            <Link to="/podroz" className="btn btn-orange blink-link--orange mt-3 mt-md-0 mx-auto mr-md-0 w-auto px-3">
                                SPRAWDŹ TRANSPORT ZORGANIZOWANY
                            </Link>
                        </div>
                    ) : null}
                </div>
            </div>
        </header>
    )
}

export default Header
